import { IngredientTabsEnum, PAGE_LIMIT, TabEnum } from 'constants/index';
import { IngredientsPayload } from 'generated/graphql';

export type State = {
  page: number;
  count: number;
  search: string;
  source: string;
  isActive: TabEnum;
  rowsPerPage: number;
  activeTab: IngredientTabsEnum;
  data: IngredientsPayload['data'];
};

export const initialState: State = {
  page: 1,
  count: 0,
  data: [],
  search: '',
  source: '',
  isActive: TabEnum.Active,
  rowsPerPage: PAGE_LIMIT,
  activeTab: IngredientTabsEnum.GENERAL,
};

export enum ActionType {
  SET_PAGE = 'setPage',
  SET_DATA = 'setData',
  SET_COUNT = 'setCount',
  SET_SEARCH = 'setSearch',
  SET_SOURCE = 'setSource',
  SET_IS_ACTIVE = 'setIsActive',
  SET_ACTIVE_TAB = 'setActiveTab',
  SET_ROWS_PER_PAGE = 'setRowsPerPage',
}

export type Action =
  | { type: ActionType.SET_PAGE; page: number }
  | { type: ActionType.SET_COUNT; count: number }
  | { type: ActionType.SET_SEARCH; search: string }
  | { type: ActionType.SET_SOURCE; source: string }
  | { type: ActionType.SET_ROWS_PER_PAGE; rowsPerPage: number }
  | { type: ActionType.SET_IS_ACTIVE; isActive: TabEnum }
  | { type: ActionType.SET_DATA; data: IngredientsPayload['data'] }
  | { type: ActionType.SET_ACTIVE_TAB; activeTab: IngredientTabsEnum };

export const ingredientReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PAGE:
      return {
        ...state,
        page: action.page,
      };

    case ActionType.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };

    case ActionType.SET_COUNT:
      return {
        ...state,
        count: action.count,
      };

    case ActionType.SET_DATA:
      return {
        ...state,
        data: action.data,
      };

    case ActionType.SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };

    case ActionType.SET_SOURCE:
      return {
        ...state,
        source: action.source,
      };

    case ActionType.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };

    case ActionType.SET_IS_ACTIVE:
      return {
        ...state,
        isActive: action.isActive,
      };
  }
};
